import { useTranslation } from "react-i18next";
import {
  CustomizationNotAvailable as NotAvailableImg
} from "../../assets/images/CustomizationNotAvailable";
import styles from "./not-available.module.scss";

export const CustomizationNotAvailable = () => {
  const { t } = useTranslation();

  return (
    <div className={styles["customization-not-available"]}>
      {NotAvailableImg}

      <div className={styles["customization-not-available__desc"]}>
        {t('innerLayout.checkoutCustomizationPage.customizationNotAvailable')}
      </div>
    </div>
  )
}
